import { useTranslation } from 'react-i18next'
import { useDeleteDestinationMutation } from '@/entities/destination'
import { DeleteButtonWithConfirm } from '@/shared/ui/delete-button-with-confirm'

interface DestinationDeleteButtonProps {
  destinationId: string
  onDeleted?: () => void
}

export function DestinationDeleteButton({
  destinationId,
  onDeleted,
}: DestinationDeleteButtonProps) {
  const { t } = useTranslation()
  const mutation = useDeleteDestinationMutation()

  return (
    <DeleteButtonWithConfirm
      onDelete={async () => {
        await mutation.mutateAsync(destinationId)
      }}
      isPending={mutation.isPending}
      confirmTitle={t('destination.deleteConfirm', { defaultValue: 'Delete this destination?' })}
      successMessage={t('destination.deleteSuccess', { defaultValue: 'Destination deleted' })}
      {...(onDeleted ? { onDeleted } : {})}
    />
  )
}
